import './style.scss';
import NumberInput from './numberinput.js';

export default NumberInput;